import { Component, Input, Output, HostListener, EventEmitter, OnInit } from '@angular/core';
import { IChangeCallback } from '../../_entities';

export abstract class EditableDropDownComponentBase<T> implements OnInit {
    private blurTimeout;
    private _originalValue: T;
    private _originalSelectedValue: T;

    ngOnInit() {
        this.updateItemList();
    }

    onSave() {
        if (this.hasUnsavedChanges) {
            this.isSaving = true;
            this.errorMessage = null;
            this.changeCallback.emit({
                id: this.id,
                newValue: this.selectedItem,
                oldValue: this._originalValue,
                resolve: () => {
                    this._originalValue = this.selectedItem;
                    this._originalSelectedValue = this.selectedItem;
                    this.isSaving = false;
                    this.hovering = false;
                    this.hasUnsavedChanges = false;
                },
                reject: (message: string) => {
                    this.isSaving = false;
                    this.errorMessage = message;
                }
            });
        } else {
            this.onCancel();
        }
    }
    onCancel() {
        this.selectedItem = this._originalSelectedValue;
        this.hovering = false;
        this.hasUnsavedChanges = false;
        this.errorMessage = null;
    }
    onChange() {
        this.errorMessage = null;
        this.hasUnsavedChanges = this.selectedItem !== this._originalSelectedValue;
    }

    getText(item: T) {
        if (item)
            return this.getDisplayValue(item);

        return "";
    }

    protected updateItemList() {
        this.items = null;
        let getItemsPromise = this.getItems();
        this.isLoadingItems = true;
        getItemsPromise.then(items => {
            this.items = items;
            this.selectedItem = this.selectedItem ? this.mapItem(this.items, this.selectedItem) : null;
            this._originalSelectedValue = this.selectedItem;
            this.isLoadingItems = false;
        });
    }
    protected abstract getItems(): Promise<T[]>;
    protected abstract mapItem(items: T[], item: T): T;
    protected abstract getDisplayValue(item: T);
    protected onItemSelected(item: T) {
        if (this.items) {
            this.selectedItem = item ? this.mapItem(this.items, item) : null;
        } else {
            this.selectedItem = item;
        }
        this._originalValue = item;
    }
    
    @Input() id: string;
    @Input('selectedItem') set selectedItemValue(val: T) {
        this.onItemSelected(val);
    }
    @Output() changeCallback = new EventEmitter<IChangeCallback<T>>();
    @Input('allowEmpty') set setAllowEmpty(val: any) {
        //console.log("Allow Empty", typeof val);
        if (typeof val === 'string') {
            this.allowEmpty = val.toLowerCase() === 'true';
            return;
        }
        this.allowEmpty = val;
    }
    @Input() placeholder: string;

    get originalValueDisplayValue() {
        return this.getText(this._originalValue) || (this.allowEmpty ? " - " : null);
    }
    items: T[];
    selectedItem: T;
    isLoadingItems: boolean;
    nullValue = null;
    hovering: boolean;
    errorMessage: string;
    isSaving: boolean;
    hasUnsavedChanges: boolean;
    allowEmpty = false;

    @HostListener('mouseenter') onMouseEnter() { this.hovering = true; }
    @HostListener('mouseleave') onMouseLeave() { this.hovering = false; }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/editable-dropdown.base.component.ts